import { GetQuotationClientRequest } from '../../../@types/GetQuotation'
import { useRequestQuotationStore } from '../../../Stores/useRequestQuotationStore'

export const useGetQuotationPayload = () => {
  const { requestQuotation } = useRequestQuotationStore()

  const useGetQuotationPayload: GetQuotationClientRequest = {
    paging: {
      pageNumber: 1, //TODO: validate where to get this
      pageSize: 10, //TODO: validate where to get this
      totalItemCount: 10, //TODO: validate where to get this
    },
    quotationId: requestQuotation?.quotationId || '',
  }

  return useGetQuotationPayload
}
